import { API_CHECK_APPT_USER_EXIST, API_PUBLIC_VERIFY_OTP, API_SEND_REG_OTP } from 'api/endpoint';
import axios from 'axios';

export const checkApptUserExist = (data) => {
  return axios.get(API_CHECK_APPT_USER_EXIST, data);
};

/**Bug #802 Midhila Velayudhan 22 march 2022 */
export const verifyRegotp = (patientLinkNumber, otp)=>{
  return axios.get(API_PUBLIC_VERIFY_OTP, {
    params:{
      patientLinkNumber:patientLinkNumber,
      otp:otp
    }
  })
};
/** Date :24 march 2022 */
export const sendRegOtp =(patientLinkNumber)=>{
  return axios.get(API_SEND_REG_OTP,{
    params:{
      patientLinkNumber:patientLinkNumber
    }
  })
}
/** End #802 */